import React, { useState, useEffect } from "react";
import Sidebar from "../components/sidebar";
import Card from "react-bootstrap/Card";
import DataTable from "react-data-table-component";
import axios from "axios";
import * as FaIcons from "react-icons/fa";
import Cargando from "../components/cargando";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import SinPermisos from "./../components/sinpermisos";
import Nav from "react-bootstrap/Nav";

const url = "https://api.mrcirp.com/public/brevocampanas";
const urlupdate = "https://api.mrcirp.com/public/brevocampanasupdate";
const urldelete = "https://api.mrcirp.com/public/brevocampanasdelete";
const urlUsuarios = "https://api.mrcirp.com/public/usuarios";
const urlCampanasAudiencia = "https://api.mrcirp.com/public/campanas-audiencia";

const Brevo = () => {
  const [users, setUsers] = useState([]);
  const [campanas, setCampanas] = useState([]);

  const [data, setData] = useState([]);
  const [buscar, setBuscar] = useState("");
  const [filtrobuscar, setFiltroBuscar] = useState([]);

  const [pending, setPending] = useState(true);
  const paginationComponentOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  const [Error, setError] = useState(false);

  const [modalAgregar, setModalAgregar] = useState(false);
  const [modalEditar, setModalEditar] = useState(false);
  const [modalEliminar, setModalEliminar] = useState(false);

  const [datosSeleccionados, setDatosSeleccionados] = useState({
    id: "",
    id_campana: "",
    campana: "",
    user_id: "",
    api_key: "",
  });

  const [nuevoBrevo, setNuevoBrevo] = useState({
    id_campana: "",
    campana: "",
    user_id: "",
    api_key: "",
  });

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem("loginUser");
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
    }
  }, []);

  useEffect(() => {
    if (users.id) {
      peticionGetCampanas(users.id);
      peticionGet();
    }
  }, [users.id]);

  const peticionGetCampanas = async (userId) => {
    try {
      // Igual que Mislanding: traer campañas de video + audiencia y unirlas
      const [responseVideo, responseAudiencia] = await Promise.all([
        axios.get(urlUsuarios),
        axios.get(urlCampanasAudiencia),
      ]);

      const filteredVideo = (responseVideo.data || []).filter(
        (item) => item.creador === userId
      );
      const filteredAudiencia = (responseAudiencia.data || []).filter(
        (item) => item.admin_id === userId
      );

      const videoCampaigns = filteredVideo.map((item) => ({
        id_campana: `video-${item.id ?? item.usuario ?? Math.random().toString(36).slice(2)}`,
        campana: item.nombrecampana || item.nombre_campana || item.usuario || "Sin nombre",
        tipo: "video",
      }));

      const audienciaCampaigns = filteredAudiencia.map((item) => ({
        id_campana: `audiencia-${item.id ?? item.enlace_campana ?? Math.random().toString(36).slice(2)}`,
        campana: item.nombre_campana || item.nombrecampana || item.enlace_campana || "Sin nombre",
        tipo: "audiencia",
      }));

      setCampanas([...videoCampaigns, ...audienciaCampaigns]);
    } catch (error) {
      console.error("Error al obtener las campañas:", error);
    }
  };

  useEffect(() => {
    const result = data.filter((resultdata) => {
      const camp = (resultdata.campana || "").toLowerCase();
      const listId = (resultdata.user_id || "").toLowerCase();
      return camp.includes(buscar.toLowerCase()) || listId.includes(buscar.toLowerCase());
    });
    setFiltroBuscar(result);
  }, [buscar, data]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPending(false);
    }, 100);
    return () => clearTimeout(timeout);
  }, []);

  const peticionGet = async () => {
    await axios.get(url + "/" + users.id).then((response) => {
      setData(response.data);
      setFiltroBuscar(response.data);
    });
  };

  const abrirModalAgregar = () => setModalAgregar(true);
  const abrirModalEditar = () => setModalEditar(true);
  const abrirModalEliminar = () => setModalEliminar(true);

  const handleNuevoBrevoChange = (e) => {
    const { name, value } = e.target;
    if (name === "id_campana") {
      const selectedCampana = campanas.find((c) => String(c.id_campana) === String(value));
      setNuevoBrevo((prevState) => ({
        ...prevState,
        id_campana: value,
        campana: selectedCampana ? selectedCampana.campana : "",
      }));
    } else {
      setNuevoBrevo((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const handleEditarChange = (e) => {
    const { name, value } = e.target;
    if (name === "id_campana") {
      const selectedCampana = campanas.find((c) => String(c.id_campana) === String(value));
      setDatosSeleccionados((prevState) => ({
        ...prevState,
        id_campana: value,
        campana: selectedCampana ? selectedCampana.campana : "",
      }));
    } else {
      setDatosSeleccionados((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const peticionPost = async () => {
    const nuevoBrevoConUsuario = {
      ...nuevoBrevo,
      usuario_id: users.id,
    };

    await axios
      .post(url, nuevoBrevoConUsuario)
      .then(() => {
        peticionGet();
        setError(false);
        setModalAgregar(false);
        setNuevoBrevo({ id_campana: "", campana: "", user_id: "", api_key: "" });
      })
      .catch(() => {
        setError(true);
      });
  };

  const peticionPut = async () => {
    await axios
      .put(urlupdate + "/" + datosSeleccionados.id, datosSeleccionados)
      .then(() => {
        peticionGet();
        setError(false);
        setModalEditar(false);
      })
      .catch(() => {
        setError(true);
        setModalEditar(false);
      });
  };

  const peticionEliminar = async () => {
    try {
      await axios.delete(`${urldelete}/${datosSeleccionados.id}`);
      peticionGet();
      setError(false);
      setModalEliminar(false);
    } catch (err) {
      setError(true);
      setModalEliminar(false);
    }
  };

  const columns = [
    {
      name: "Accion",
      button: true,
      cell: (row) => (
        <Nav style={{ display: "flex", justifyContent: "space-between" }}>
          <button
            onClick={() => {
              setDatosSeleccionados(row);
              abrirModalEditar();
            }}
            className="custom-btn"
            style={{ marginRight: "25px" }}
            title="Editar"
          >
            <FaIcons.FaRegEdit />
          </button>
          <button
            onClick={() => {
              setDatosSeleccionados(row);
              abrirModalEliminar();
            }}
            className="custom-btn"
            style={{ marginRight: "5px" }}
            title="Eliminar"
          >
            <FaIcons.FaRegTrashAlt />
          </button>
        </Nav>
      ),
    },
    {
      name: "Id",
      selector: (row) => row.id,
      defaultSortAsc: true,
      sortable: true,
      maxWidth: "80px",
    },
    {
      name: "Campaña",
      selector: (row) => row.campana,
      wrap: true,
    },
    {
      name: "ID lista (Brevo)",
      selector: (row) => row.user_id,
      wrap: true,
    },
    {
      name: "API KEY",
      selector: (row) => (row.api_key ? "✓ Configurada" : "No configurada"),
      wrap: true,
      maxWidth: "160px",
    },
  ];

  if (users.rol !== undefined) {
    if (users.rol === "cliente") {
      return (
        <div>
          <Sidebar>
            <Card className="mt-4">
              <Card.Header className="bg-dark text-white" as="h3">
                <div className="row">
                  <div className="col-md-12">Brevo</div>
                </div>
              </Card.Header>
              <Card.Body>
                <Card.Title>Brevos registrados</Card.Title>
                {Error && (
                  <div className="alert alert-danger">
                    {<strong>Error: No se pudo guardar. Verifica los datos.</strong>}
                  </div>
                )}
                <p>
                  Solo puede haber un Brevo registrado por campaña. Si guardas de nuevo para la misma campaña,
                  se actualiza el registro existente.
                </p>
                <button className="btn btn-info" onClick={abrirModalAgregar}>
                  Añadir Brevo
                </button>

                <DataTable
                  columns={columns}
                  data={filtrobuscar}
                  noDataComponent="No hay brevos"
                  progressPending={pending}
                  progressComponent={<Cargando />}
                  pagination
                  paginationComponentOptions={paginationComponentOptions}
                  subHeader
                  subHeaderComponent={
                    <input
                      type="text"
                      placeholder="Buscar por campaña o ID lista"
                      className="w-25 form-control"
                      value={buscar}
                      onChange={(e) => setBuscar(e.target.value)}
                    />
                  }
                />

                <Modal isOpen={modalEliminar}>
                  <ModalHeader>
                    <div>
                      <h4>Eliminar Brevo</h4>
                    </div>
                  </ModalHeader>
                  <ModalBody>
                    <div className="form-group">
                      <h5>¿Desea eliminar la configuración de Brevo #{datosSeleccionados.id}?</h5>
                      <p className="mb-0">
                        <strong>Campaña:</strong> {datosSeleccionados.campana}
                      </p>
                    </div>
                  </ModalBody>
                  <ModalFooter>
                    <button className="btn btn-dark" onClick={() => setModalEliminar(false)}>
                      Cancelar
                    </button>
                    <button className="btn btn-danger" onClick={() => peticionEliminar()}>
                      Eliminar
                    </button>
                  </ModalFooter>
                </Modal>

                <Modal isOpen={modalEditar}>
                  <ModalHeader>
                    <div>
                      <h5>Editar Brevo</h5>
                    </div>
                  </ModalHeader>
                  <ModalBody>
                    <div className="form-group">
                      <input className="form-control" readOnly type="hidden" name="id" value={datosSeleccionados.id} />

                      <label>Campaña</label>
                      <select
                        className="form-control"
                        name="id_campana"
                        value={datosSeleccionados.id_campana || ""}
                        onChange={handleEditarChange}
                      >
                        <option value="">Seleccione una opción</option>
                        {campanas.map((c) => (
                          <option key={c.id_campana} value={c.id_campana}>
                            {c.campana}
                          </option>
                        ))}
                      </select>
                      <br />
                      <label>ID de lista de Brevo</label>
                      <input
                        className="form-control"
                        type="text"
                        name="user_id"
                        value={datosSeleccionados.user_id}
                        onChange={handleEditarChange}
                      />
                      <br />
                      <label>API KEY de Brevo</label>
                      <input
                        className="form-control"
                        type="password"
                        name="api_key"
                        value={datosSeleccionados.api_key}
                        onChange={handleEditarChange}
                      />
                    </div>
                  </ModalBody>
                  <ModalFooter>
                    <button className="btn btn-dark" onClick={() => setModalEditar(false)}>
                      Cancelar
                    </button>
                    <button className="btn btn-info" onClick={() => peticionPut()}>
                      Actualizar
                    </button>
                  </ModalFooter>
                </Modal>

                <Modal isOpen={modalAgregar}>
                  <ModalHeader>
                    <div>
                      <h5>Añadir Brevo</h5>
                    </div>
                  </ModalHeader>
                  <ModalBody>
                    <div className="form-group">
                      <label>Campaña</label>
                      <select
                        className="form-control"
                        name="id_campana"
                        value={nuevoBrevo.id_campana || ""}
                        onChange={handleNuevoBrevoChange}
                      >
                        <option value="">Seleccione una opción</option>
                        {campanas.map((c) => (
                          <option key={c.id_campana} value={c.id_campana}>
                            {c.campana}
                          </option>
                        ))}
                      </select>
                      <br />
                      <label>ID de lista de Brevo</label>
                      <input
                        className="form-control"
                        type="text"
                        name="user_id"
                        value={nuevoBrevo.user_id}
                        onChange={handleNuevoBrevoChange}
                      />
                      <br />
                      <label>API KEY de Brevo</label>
                      <input
                        className="form-control"
                        type="password"
                        name="api_key"
                        value={nuevoBrevo.api_key}
                        onChange={handleNuevoBrevoChange}
                      />
                    </div>
                  </ModalBody>
                  <ModalFooter>
                    <button className="btn btn-dark" onClick={() => setModalAgregar(false)}>
                      Cancelar
                    </button>
                    <button className="btn btn-info" onClick={() => peticionPost()}>
                      Añadir
                    </button>
                  </ModalFooter>
                </Modal>
              </Card.Body>
            </Card>
          </Sidebar>
        </div>
      );
    }

    return (
      <div>
        <Sidebar>
          <SinPermisos />
        </Sidebar>
      </div>
    );
  }

  return (
    <div>
      <Sidebar>
        <SinPermisos />
      </Sidebar>
    </div>
  );
};

export default Brevo;

